interface InputWrapperProps {
    children: React.ReactNode;
    label: string;
    labelClassName?: string;
    validationErrorMessage?: string | null;
    inline?: boolean;
    className?: string;
}

export const InputWrapper = ({
    children,
    label,
    labelClassName = "",
    validationErrorMessage,
    inline = false,
    className = "",
}: InputWrapperProps) => {
    return (
        <div className={`input-wrapper ${inline ? "inline" : ""} ${className}`}>
            <label className={labelClassName}>{label}</label>
            {children}
            {validationErrorMessage !== null && (
                <div className="text-error">
                    {validationErrorMessage || "\u00A0"}
                </div>
            )}
        </div>
    );
};
